module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_0.e8d3db57.png";